import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import styled from 'styled-components';
import { Constants } from '../utils/Constants';
import { useQuery } from '@apollo/client';
import { GET_INXS } from '../graphql/queries';
import { IGetInxsMessagesOutput, IGetInxsMessagesInput } from '../graphql/types/queries/inxs';
import PleaseWait from '../components/PleaseWait';
import { InxsContent } from './inxs/InxsContent';

const Container = styled(Flex)`
  /* padding: ${() => `${Constants.OUTLETS_PADDING_MOBILE}px`}; */
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP_MOBILE}px`};
  width: 100%;
  @media screen and (min-width: 68.8125em) {
  padding: ${() => `${Constants.OUTLETS_PADDING}px`};
  padding-right: ${() => `12px`};
  padding-top: ${() => `1px`};
  min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
  }
`

interface IInxsProps {

}

export const Inxs: React.FC<IInxsProps> = ({ }) => {
  const { data, loading, error } = useQuery<IGetInxsMessagesOutput, IGetInxsMessagesInput>(GET_INXS,{
    fetchPolicy: 'network-only'
  })
  return (
    <Container id='ctnr' flex={1} width={'100%'} flexDirection={'column'} style={{ height: '100%', maxHeight: '100%' }} overflow={['hidden']}>
      <Flex flexDirection={['column']} alignItems={'flex-start'} height={'fit-content'} mb={4} paddingTop={`${Constants.OUTLETS_PADDING_TOP}px`} >
        <Heading mb={3}>INxS (Internal Notifications Cross Services)</Heading>
        <Text>This is the list of internal notifications for you</Text>
      </Flex>
      <Flex id='content' flex={1} width={'100%'} height='100%' overflow={'hidden'}>
        {!!loading ? (
          <Flex flex={1} justifyContent={'center'} alignItems={'center'}>
            <PleaseWait />
          </Flex>
        ) : (
          <>
            {!data || !data.getHealthCoachInxs ? (
              <Text>An error occured</Text>
            ):(
              <InxsContent data={data.getHealthCoachInxs} />
            )}
          </>
        )}
      </Flex>
    </Container>

  );
}